/* 名前変更 */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from '../../axios';
import { api_response_type } from '../../Const';
import { handleBrowserBack } from '../../BrowserBack';
import CenterButton from '../../atoms/CenterButton';
import ValidMessage from '../../atoms/ValidMessage';
import Block from '../../molecules/Block';
import Popup from '../../molecules/Popup';
import LoadingModal from '../../molecules/LoadingModal';
import TransitionButton from '../../molecules/TransitionButton';
import HorizontalInputField from '../../molecules/HorizontalInputField';

const ChangeName = () => {
  const [input_name, setInputName] = useState({ first_name: '', last_name: '' });
  // エラーメッセージ
  const [valid_message, setValidMessage] = useState('');
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(false);
  // ダイアログの表示フラグ
  const [is_dialog_confirm, setIsDialogConfirm] = useState(false);
  const [is_dialog_complete, setIsDialogComplete] = useState(false);

  // 初期処理：変更前の名前を取得
  const node = document.getElementById('change-name');
  const initial_first_name = node?.dataset.login_user_first_name as string;
  const initial_last_name = node?.dataset.login_user_last_name as string;
  // 初期処理：変更不可フラグを取得
  const unchangeable_flg = node?.dataset.unchangeable_flg ? true : false;

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  /**
   * 入力された名前をstateにセットする処理
   * @param event インプットイベント
   */
  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    setInputName({ ...input_name, [name]: value });
  };

  /**
   * 【マイページに戻る】ボタン押下時の処理
   */
  const handleReturnToMypage = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/mypage/list`;
  };

  /**
   * 確認モーダル内の【戻る】ボタン押下時の処理
   */
  const handleReturn = () => {
    // 確認モーダルを閉じる
    setIsDialogConfirm(false);
  };

  /**
   * 確認モーダル内の【変更する】ボタン押下時の処理
   */
  const handleChangeName = async () => {
    try {
      // エラーメッセージを初期化
      setValidMessage('');
      // 確認のモーダルを閉じる
      setIsDialogConfirm(false);
      // ローディング画面表示
      setIsLoading(true);

      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/change_name_confirm`,
        input_name
      );

      if (response.data.response_type === api_response_type.transition_to_list) {
        // 完了のモーダルを開く
        setIsDialogComplete(true);
      }
    } catch (error) {
      if (error.response.data.response_type === api_response_type.validation) {
        // 姓と名両方、またはどちらかが空であればエラーを表示する
        const message = error.response.data.message;
        setValidMessage(message.first_name ? message.first_name[0] : message.last_name ? message.last_name[0] : message.name[0]);
      } else {
        alert('システムエラーが発生しました');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mt-5">
      <Block
        label="名前変更"
        content={
          <>
            {unchangeable_flg && (
              <strong className="p-lead is-invalid">
                お手続き中はお名前の変更ができません。お手続き完了後、お名前を変更して下さい。
              </strong>
            )}
            <p className="p-lead my-4">ご登録のお名前を変更します。</p>
            <div className="mt-3">
              <div className="form-row">
                <div className="field-label col-md-4">現在のお名前</div>
                <div className="field-label-text false col-md-8">
                  <div className="row align-items-center">
                    <p className="col-5 mb-0 pt-2">{initial_first_name}</p>
                    <p className="col-5 mb-0 pt-2 pl-0">{initial_last_name}</p>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="field-label col-md-4">新しいお名前</div>
                <div className="field-label-text col-md-8">
                  <div className="row initial-name">
                    <HorizontalInputField
                      name="first_name"
                      placeholder="田中"
                      valid_message={valid_message}
                      unchangeable_flg={unchangeable_flg}
                      handleInput={handleInput}
                    />
                    <HorizontalInputField
                      name="last_name"
                      placeholder="太郎"
                      valid_message={valid_message}
                      unchangeable_flg={unchangeable_flg}
                      handleInput={handleInput}
                    />
                  </div>
                  {valid_message.length !== 0 && <ValidMessage message={valid_message} />}
                  <span className="help-msg">※左項目に姓、右項目に名を入力して下さい</span>
                </div>
              </div>
            </div>
            <CenterButton
              btn_class="arrow-right arrow-right-disabled-white my-5 btn-space"
              label="名前を変更する"
              is_disabled={unchangeable_flg}
              handleClick={() => setIsDialogConfirm(true)}
            />
            <TransitionButton
              label="マイページへ戻る"
              btn_class="two_lines"
              handleClick={handleReturnToMypage}
            />
            <Popup
              title="名前変更確認"
              text="ご登録のお名前の変更を行います。よろしいですか？"
              first_button={{
                label: '変更する',
                variant: 'success',
                handleClick: handleChangeName,
              }}
              second_button={{
                label: '戻る',
                variant: 'outline-success',
                handleClick: handleReturn,
              }}
              toggleClose={handleReturn}
              toggleShow={is_dialog_confirm}
            />
            <Popup
              title="名前変更完了"
              text="ご登録のお名前の変更が完了しました。"
              first_button={{
                label: '閉じる',
                variant: 'outline-success',
                handleClick: handleReturnToMypage,
              }}
              toggleClose={handleReturnToMypage}
              toggleShow={is_dialog_complete}
            />
          </>
        }
      />
      <LoadingModal show={is_loading} />
    </div>
  );
};
if (document.getElementById('change-name')) {
  ReactDOM.render(<ChangeName />, document.getElementById('change-name'));
}
